import React from 'react';
import { Box, Flex, Modal, ModalOverlay, ModalBody, ModalContent, Image } from '@chakra-ui/react';

import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import welcomeImage from '../styles/images/launchdeck-new-user-welcome.png'

export default function NewUserTourStartModal({
  isMobileView,
  handleStartTour,
  handleDismissMobileWelcome,
  newUserTourIsActive,
  newUserTourCompleted,
  showNewUserMobileWelcome
}) {

  if (isMobileView) {
    if (showNewUserMobileWelcome) {
      return (
      <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} >
      <ModalOverlay className="modal-background" />
      <ModalContent rounded='0.25em' minW={['90%', '500px']} maxW={['90%', '700px']}>
        <ModalBody px='0em' >
          <Flex
            direction='column'
            justify='center'
            alignItems='center'
            w='100%'
            p='1em'
            gap={'2em'}
            className='fade-in'
          >
            <Box fontSize='1.5em' fontWeight='600'>Aloha from Launchdeck</Box>
  
            <Box boxSize='10em' rounded='0.5em'>
              <Image src={welcomeImage} rounded='0.5em' />
            </Box>
  
            <Box fontSize='0.875em' textAlign='center' maxW='80%'>
              <Box >We’re glad you’ve decided to come along for the ride. </Box>
  
              <Box mt='1em'>Here, you'll find your Rooms, including those received from others.</Box>
  
              <Box mt='1em'> To create your own Rooms, try Launchdeck out on a computer where our editing features come to life!</Box>
            </Box>
            <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleDismissMobileWelcome()} label='Got it!' />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
      )
    }
  } else {
    if (!newUserTourIsActive && !newUserTourCompleted) {
      return (
        <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} >
          <ModalOverlay className="modal-background" />
          <ModalContent rounded='0.25em' minW={['90%', '500px']} maxW={['90%', '700px']}>
            <ModalBody px='0em' >
              <Flex
                direction='column'
                justify='center'
                alignItems='center'
                w='100%'
                p='1em'
                gap={'2em'}
                className='fade-in'
              >
                <Box fontSize='1.5em' fontWeight='600'>Aloha from Launchdeck</Box>
  
                <Box boxSize='15em' rounded='0.5em'>
                  <Image src={welcomeImage} rounded='0.5em' />
                </Box>
  
                <Box fontSize='0.875em' textAlign='center' maxW='80%'>
                  <Box >We’re glad you’ve decided to come along for the ride. </Box>
  
                  <Box mt='1em'>To help you achieve success in the shortest possible time, here’s a no-nonsense tour of Launchdeck</Box>
                </Box>
                <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleStartTour()} label='Start' />
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      )
    } else return null
  }
  


}

